// extracted by mini-css-extract-plugin
export var chevronIcon = "_ch-2";
export var teamName = "_ch-1";
export var teamSwitcherButton = "_ch-0";